import script from "./ShowYear.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowYear.vue?vue&type=script&setup=true&lang=js"

import "./ShowYear.vue?vue&type=style&index=0&id=b8ed6050&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8ed6050"]])

export default __exports__